export const MAXWELL_PLAYER_EVENT = 'player-monitoring';
export const MAXWELL_TRACKER_UNKNOWN = 2;
export const MAXWELL_TRACKER_OK = 0;
export const MAXWELL_TRACKER_NOT_OK = 1;
export const MAXWELL_AD_MODE_ACTIVATED = 1;
export const MAXWELL_AD_MODE_DEACTIVATED = 0;
